'use client';

import React from 'react';
import { useModalProvider } from '@dr-pam/common-components/Components/Modal/ModalProvider';
import GetAccessOptions from './GetAccessOptions';

const MODAL_ID = 'get-access';

export default function GetAccessModal() {
	const modalProvider = useModalProvider();

	return (
		<div className="get-access-modal">
			<h2 className="get-access-modal__title">Sign up</h2>
			<GetAccessOptions onSelect={() => modalProvider.closeModal(MODAL_ID)} />
		</div>
	);
}

export function showGetAccessModal(modalProvider: ReturnType<typeof useModalProvider>) {
	modalProvider.openModal({
		modalId: MODAL_ID,
		className: 'popup-overlay blur',
		showClose: true,
		children: <GetAccessModal />,
	});
}
